import { useMemo } from 'react';
import { domainApi } from '../api';
import { useMutation } from '@tanstack/react-query';
import { setDomainData } from '../context/domainAtoms';

export enum DomainSearchStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
  Unsupported = 'UNSUPPORTED',
}

export const useDomainSearch = (searchValue: string) => {
  const {
    data,
    mutate: searchDomain,
    isPending: isSearching,
    isError,
    reset: resetSearch,
  } = useMutation({
    mutationFn: () => domainApi.checkDomainAvailability(searchValue),
    onSuccess: (response) => {
      if (response?.availability?.available) {
        setDomainData({
          availableDomain: response.availability.domain,
        });
      }
    },
  });

  const searchStatus = useMemo<DomainSearchStatus>(() => {
    if (isError) {
      return DomainSearchStatus.Unsupported;
    }
    if (data) {
      return data.availability.available ? DomainSearchStatus.Available : DomainSearchStatus.Unavailable;
    }
  }, [isError, data]);

  return { searchDomain, isSearching, searchStatus, resetSearch };
};
